/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));

  var justAddedLimitedItem = false;

  // 対象商品のバリアントIDではなく商品IDで管理
  var limitedProductIds = [
    8823269556421,  // 【個数限定販売】小葉で味わう上勝阿波晩茶 80g
    8790006038725,  // 【LINE会員限定】上勝阿波晩茶 100g（お一人様1個限り）
    8419358474437,  // 【LINE会員限定】上勝阿波晩茶 100g（お一人様1個まで）
    8198628376773,  // 【個数限定】上勝阿波晩茶×野ぶどうサプリ3袋
    7660005982405,   // ※完売御礼※【先着50名様限定】上勝阿波晩茶×野ぶどうサプリ3袋
    8051853394117,   // 【2026年産】無農薬　上勝阿波晩茶(ティーバッグタイプ)　3g×8p
    7451899822277   // 【定期便】上勝阿波晩茶×野ぶどうサプリアソート ※おひとり様1セット限り
  ];

  const _fetch = window.fetch;
  window.fetch = function() {
    const url = arguments[0];
    const result = _fetch.apply(this, arguments);
    if (typeof url === 'string' && url.includes('/cart/add')) {
      result.then(function(response) {
        return response.clone().json();
      }).then(function(data) {
        if (data.product_id && limitedProductIds.indexOf(data.product_id) !== -1) {
          justAddedLimitedItem = true;
        }
      }).catch(function() {});
    }
    return result;
  };

  document.addEventListener('theme:cart:change', function(event) {
    if (justAddedLimitedItem) {
      justAddedLimitedItem = false;
      var modal = document.getElementById('purchase-limit-modal');
      if (modal) modal.style.display = 'flex';
    }
  });

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
